import TemplateView from '../../../../TemplateView'
import TableHeader from './TableHeader'
import WorkScheduleList from './WorkScheduleList'
import InitialScheduleRow from './InitialScheduleRow'
import messageResource from '../../../../messageResource'
import LoadingContainer from '../../../../util/LoadingContainer'

export default class WorkScheduleTable extends TemplateView {
    constructor({
        readOnly,
        editMode = true,
        scrollTo = () => {},
        onInitialScheduleChanged = () => {},
        onWorkScheduleChanged = () => {},
        deleteWorkSchedule = () => {},
        addNewSchedule = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()

        this.params = {
            readOnly,
            editMode,
            scrollTo,
        }

        this.callbacks = {
            onInitialScheduleChanged,
            onWorkScheduleChanged,
            deleteWorkSchedule,
            addNewSchedule,
            refreshScrollCb,
            subscribeSelectorOnScroll,
        }

        this.state = {
            isDefaultInitialSchedule: false,
            initialSchedule: [],
            workSchedule: [],
            defaultWorkSchedule: [],
            readOnly: this.params.readOnly,

            currentDate: null,
            weekStartDay: 0,
            invertedDays: {},
            decimalSeparator: null,

            updating: false,
        }

        this.onAnyStatePropertyChanged([
                'isDefaultInitialSchedule',
                'initialSchedule',
                'workSchedule',
                'defaultWorkSchedule',
                'currentDate',
                'weekStartDay',
                'invertedDays',
                'decimalSeparator',
                'readOnly',
            ],
            () => {
                this.workScheduleList.setState({
                    isDefaultInitialSchedule: this.state.isDefaultInitialSchedule,
                    defaultWorkSchedule: this.state.defaultWorkSchedule,
                    workSchedule: this.state.workSchedule,

                    currentDate: this.state.currentDate,
                    weekStartDay: this.state.weekStartDay,
                    invertedDays: this.state.invertedDays,
                    decimalSeparator: this.state.decimalSeparator,
                    readOnly: this.state.readOnly,
                })

                const isInitialScheduleEffective = !this.state.workSchedule.find(
                    s => s.effectiveDate && s.effectiveDate.parseJSONDate() <= this.state.currentDate.parseJSONDate())

                this.initialSchedule.setState({
                    isDefaultInitialSchedule: this.state.isDefaultInitialSchedule,
                    initialSchedule: this.state.initialSchedule,
                    weekStartDay: this.state.weekStartDay,
                    effective: isInitialScheduleEffective,
                    readOnly: this.state.readOnly,
                })

                this.$addRecordButton.toggle(!this.state.readOnly)
            })

        this.onStatePropertyChanged('weekStartDay', weekStartDay => this.tableHeader.setState({weekStartDay}))
        this.onStatePropertyChanged('updating', loading => this.loadingWrapper.setState({loading}))
    }

    templateHtml() {
        return '<div class="workScheduleTable">' +
               '    <div class="tableHeader"/>' +
               '    <div class="workSchedulesContainer"></div>' +
               '    <% if (params.editMode) { %>' +
               '    <div class="addRecordButtonPlaceholder">' +
               '        <div class="addRecordButton">' +
               '            <div class="icon"/>' +
               '            <span class="label"><%=newScheduleLabel%></span>' +
               '        </div>' +
               '    </div>' +
               '    <% } %>' +
               '</div>'
    }

    messageKeys() {
        return {
            newScheduleLabel: 'user.add_edit.js.wd_editor.new_schedule'
        }
    }

    afterRender() {
        this.$addRecordButton = this.find('.addRecordButton')
        this.tableHeader = new TableHeader().init(this.find('.tableHeader'))

        this.initialSchedule = new InitialScheduleRow({
            readOnly: this.params.readOnly,
            scheduleHeaderLabel: messageResource.getMessage('user.add_edit.js.wd_editor.initial_schedule_row_header'),
            scrollTo: this.params.scrollTo,
            onChangeCb: this.callbacks.onInitialScheduleChanged,
        })

        this.workScheduleList = new WorkScheduleList({
            editMode: this.params.editMode,
            readOnly: this.params.readOnly,
            scrollTo: this.params.scrollTo,
            onScheduleChanged: this.callbacks.onWorkScheduleChanged,
            deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
            refreshScrollCb: this.callbacks.refreshScrollCb,
            subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
        })

        this.loadingWrapper = new LoadingContainer({
            contentComponent: [this.initialSchedule, this.workScheduleList],
            proxySetState: false,
            loadingMoireConfig: {
                delay: 500
            },
        }).init(this.find('.workSchedulesContainer'))

        if (this.params.editMode && !this.params.readOnly)
            this.$addRecordButton.click(() => this.callbacks.addNewSchedule())

        this.$addRecordButton.toggle(!this.params.readOnly)
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/WorkScheduleTable.js